export default "__VITE_ASSET__C$bcFrhi__"